import { render, staticRenderFns } from "./CurrencyCell.vue?vue&type=template&id=08460280&scoped=true&"
import script from "./CurrencyCell.vue?vue&type=script&lang=js&"
export * from "./CurrencyCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08460280",
  null
  
)

export default component.exports